import { render } from "./CodecoCoarri.vue?vue&type=template&id=0a6f307c&scoped=true"
import script from "./CodecoCoarri.vue?vue&type=script&lang=js"
export * from "./CodecoCoarri.vue?vue&type=script&lang=js"

import "./CodecoCoarri.vue?vue&type=style&index=0&id=0a6f307c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6f307c"]])

export default __exports__